import _ from 'lodash'
import URI from 'urijs'
import React, { useState, useEffect, useMemo } from 'react'
import {
  useCommerceChannels,
} from '../../vendor/react-omnitech-api'
import useOrderMethod from '../use-order-method'
import env from '../../config/env'
import CommerceChannelContext from './commerce-channel-context'

/**
 * CommerceChannelProvider
 * Contain most logic handing navigate
 */
export default function CommerceChannelProvider({ value, children }) {
  const location = _.get(value, 'location', {})
  const {
    availableOrderMethod,
  } = useOrderMethod()
  const { fetchCommerceChannel } = useCommerceChannels()

  const [commerceChannels, setCommerceChannels] = useState(null)
  const [cacheChecksum, setCacheChecksum] = useState(null)

  const commerceChannelCacheChecksum = _.get((JSON.parse(window.localStorage.getItem('cacheChecksum'))), 'commerceChannelsValue')

  const initReady = useMemo(() => (
    !_.isNil(cacheChecksum) && _.isObject(commerceChannels)
  ), [cacheChecksum, commerceChannels])

  const cc = useMemo(() => (
    _.get(URI.parseQuery(_.get(location, 'search', '')), 'cc')
  ), [location])

  const commerceChannelCodes = useMemo(() => (
    _.uniq(
      _.compact([
        _.get(env, 'config.api.commerceChannel'),
        _.get(env, 'config.api.commerceChannelForSkuQuota'),
        cc,
        ..._.map(
          availableOrderMethod,
          'commerceChannel',
        ),
      ]),
    )
  ), [availableOrderMethod, cc])

  const commerceChannelCodesDependent = useMemo(() => (
    _.join(
      (commerceChannelCodes || []).sort(),
      '|',
    )
  ), [commerceChannelCodes])

  const fetchCommerceChannels = () => (
    Promise.all(
      _.map(commerceChannelCodes, (code) => (
        fetchCommerceChannel({ code })
      )),
    ).then((values) => {
      setCacheChecksum(_.get(values, '0.cacheChecksum', null))
      setCommerceChannels(
        _.omitBy(
          _.zipObject(
            commerceChannelCodes,
            _.map(values, 'commerceChannel'),
          ),
          _.isNil,
        ),
      )
    })
  )

  useEffect(() => {
    fetchCommerceChannels()
  }, [commerceChannelCodesDependent, commerceChannelCacheChecksum])

  const state = {
    commerceChannels,
  };

  return (
    <CommerceChannelContext.Provider value={state}>
      {initReady && children}
    </CommerceChannelContext.Provider>
  )
}
